import { render, staticRenderFns } from "./MyOrganizationKnowledgeBase.vue?vue&type=template&id=2d6e804c"
import script from "./MyOrganizationKnowledgeBase.vue?vue&type=script&lang=js"
export * from "./MyOrganizationKnowledgeBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports